import {Injectable} from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication.service';
import { EventService } from './event.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ImageService {
    constructor(
        private http: HttpClient,
        private authService: AuthenticationService,
        private eventService: EventService
    ) {}

    public formatUrl(path: string) {

		var prefixType;

		if (this.eventService.selectedEvent && this.eventService.selectedEvent.gql) {
			prefixType = this.eventService.selectedEvent.gql.Participant[0].individualConstituent.prefixType;
		}

        if (path) {
			var absolute = /^(?:[a-z]+:)?\/\//gi;
			if (absolute.test(path)) {
				return path;
			} else {
				return this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.imageUrl + path;
			}
        } else if (prefixType && prefixType.name === 'MR') {
            return 'assets/modules/dummy-assets/common/img/avatars/default-avatar-m.jpg';
        } else if (prefixType && (prefixType.name === 'MS' || prefixType.name === 'MRS' || prefixType.name === 'MISS') ) {
            return 'assets/modules/dummy-assets/common/img/avatars/default-avatar-f.jpg';
        } else {
            return 'assets/modules/dummy-assets/common/img/avatars/default-avatar.jpg';
        }
    }

    public formatUrlForProgramGroupImagePath(path: string, programGroupImagePath: string) {

        if (path) {
            var absolute = /^(?:[a-z]+:)?\/\//gi;
            if (absolute.test(path)) {
                return path;
            } else {
                return programGroupImagePath + path;
            }
        } else {
            var prefixType;

            if (this.eventService.selectedEvent && this.eventService.selectedEvent.gql) {
                prefixType = this.eventService.selectedEvent.gql.Participant[0].individualConstituent.prefixType;
            }

            if (prefixType && prefixType.name === 'MR') {
                return 'assets/modules/dummy-assets/common/img/avatars/default-avatar-m.jpg';
            } else if (prefixType && (prefixType.name === 'MS' || prefixType.name === 'MRS' || prefixType.name === 'MISS') ) {
                return 'assets/modules/dummy-assets/common/img/avatars/default-avatar-f.jpg';
            } else {
                return 'assets/modules/dummy-assets/common/img/avatars/default-avatar.jpg';
            }
		}
    }

	private escapeRegExp(str) {
		return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	}

	public getUpdateImageRegex(url: string) {
		var attribute = '(?:[\\s]+[a-z]+=[\'"][\\w\\/\\.\\-:%]*["\'])*';

		//this regex may need some work, but we alter the img tags here so that our system plays nicely with the legacy system
		return new RegExp('(\\<img'
					+ attribute
				+ '[\\s]+src=[\'"])'
				+ '(' + this.escapeRegExp(url) + ')'
				+ '(\\/[\\w\\/\\.-]+["\']'
					+ attribute
				+ '[\\s]*\\/\\>)', 'gi');
	}

    public postImage(url: string, image: File) {
        if (!url || url === '') {
            throw new Error('Url is not set! Please set it before doing queries');
        }
        let formData = new FormData();
        formData.append('files', image);
        return this.http.post(url, formData);
    }
}